const routes = [
  {
    path: "/",
    name: "MyClientsEntry",
    component: () =>
      import(
        /* webpackChunkName: "myclients" */ "@/pages/MyClients/MyClientsIndex"
      ),
    meta: {
      title: "My Clients - NutriBit",
      showSearch: true
    }
  },
  {
    path: "/clients",
    name: "MyClients",
    component: () =>
      import(
        /* webpackChunkName: "myclients" */ "@/pages/MyClients/MyClientsIndex"
      ),
    meta: {
      title: "My Clients - NutriBit",
      showSearch: true
    }
  }
];

export default routes;
